import React from 'react';
import { Monitor, DollarSign, Settings, Globe, Shield, FolderOpen, BarChart3 } from 'lucide-react';

const TabNavigation = ({ activeView, onViewChange }) => {
  const tabs = [
    { id: 'placements', label: 'Placements', icon: Monitor },
    { id: 'floors', label: 'Floors', icon: DollarSign },
    { id: 'prebid', label: 'Prebid Config', icon: Settings },
    { id: 'site', label: 'Site Settings', icon: Globe },
    { id: 'privacy', label: 'Privacy & Storage', icon: Shield },
    { id: 'management', label: 'Site Management', icon: FolderOpen },
    { id: 'analytics', label: 'Analytics', icon: BarChart3 }
  ];

  return (
    <div className="flex space-x-8 border-b border-gray-200">
      {tabs.map(({ id, label, icon: Icon }) => (
        <button
          key={id}
          onClick={() => onViewChange(id)}
          className={`flex items-center gap-2 px-4 py-3 text-sm font-medium transition-colors ${
            activeView === id
              ? 'border-b-2 border-blue-500 text-blue-600'
              : 'text-gray-500 hover:text-gray-700'
          }`}
        >
          <Icon size={16} />
          {label}
        </button>
      ))}
    </div>
  );
};

export default TabNavigation;